//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";



//--------------- FUNÇÃO ASSÍNCRONA DISABLE USER DSERVICE ---------------//
// Responsável por requisitar à API a Inativação do Usuário
export default async function disableUserService(id) {
    try {
        await api.patch(`/usuarios/${id}/inativar`);
        return true;
    } catch (err) {
        return false;
    }
}